import * as Types from './types';
import { actionTypes } from './constants';
export * from '@core/js/hooks/user/store/actions';

export const setCUBalance = (balance: string): Types.ISetCUBalanceAction => ({
    type: actionTypes.SET_CU_BALANCE,
    payload: balance
});
